import ApiHandler from '@/api/base'

class JiraDashboardApiHandler extends ApiHandler {
  async createFilterViewForDashboard({ dashboardId, dashboardPageId, filters, name }) {
    const { data } = await this.http.post('/createFilterViewForDashboard', {
      dashboardId,
      dashboardPageId,
      filters,
      name
    })
    return data
  }

  async updateFilterViewForDashboard({ dashboardId, dashboardPageId, filters, name }) {
    const { data } = await this.http.post('/updateFilterViewForDashboard', {
      dashboardId,
      dashboardPageId,
      filters,
      name
    })
    return data
  }

  async getFiltersForDashboard(dashboardId, dashboardPageId) {
    const { data } = await this.http.post('/getFiltersForDashboard', {
      dashboardId,
      dashboardPageId
    })
    return data
  }
}

export default JiraDashboardApiHandler
